import type { LandingStrings } from './en';

export const ptBR: LandingStrings = {
  header: {
    brandSubtitle: 'Loja mágica',
    contact: 'Contato',
    about: 'Sobre o jogo',
    language: 'Idioma',
  },
  footer: {
    terms: 'Termos de Uso',
    privacy: 'Política de Privacidade',
    copyright: '{year} {holder}. Todos os direitos reservados.',
  },
  home: {
    heroTitle: 'Um jogo 3D aconchegante sobre poções e uma loja mágica.',
    heroDescription:
      'Procure ingredientes no meio da bagunça mágica, prepare poções no caldeirão e venda-as na sua própria loja.',
    features: [
      {
        title: 'Seu próprio frasco',
        desc: 'Formato, tampa e cor da poção — frascos mais bonitos valem mais.',
      },
      {
        title: 'Um ofício com sentido',
        desc: 'Cada poção tem sua própria receita, e muitas funcionam de verdade no jogo.',
      },
      {
        title: 'Uma história que dá vontade de acompanhar',
        desc: 'A vovó saiu de férias e deixou a loja com você — e um sapo chamado Moren exige o que é dele.',
      },
      {
        title: 'Uma loja que é sua de verdade',
        desc: 'Só se vende o que você preparou com as próprias mãos.',
      },
    ],
    appStore: 'App Store',
    googlePlay: 'Google Play',
    comingSoon: 'Em breve',
    tags: { search: 'Busca pela sombra', craft: 'Poções no caldeirão 3D', shop: 'Loja aconchegante' },
  },
  about: {
    title: 'Sobre o Qevryno',
    intro: [
      'Boas-vindas ao Qevryno — um jogo aconchegante de preparar poções, em que a magia é feita à mão.',
      'A vovó saiu de férias e pediu para você cuidar da velha e misteriosa casa dela: receitas esquecidas, ingredientes mágicos e um caldeirão que ainda lembra como ferver. No andar de baixo há uma lojinha, e a aldeia inteira já se pergunta quem está tomando conta dela agora.',
      'Prepare poções, cuide do seu familiar fofinho, venda suas criações para clientes encantadores e ganhe moedas para decorar seu lar mágico — no seu ritmo, sem cronômetros.',
    ],
    whatTitle: 'Que tipo de jogo é este?',
    what: [
      'Qevryno é um jogo de puzzle 3D relaxante que mistura busca de objetos escondidos, alquimia e um pequeno simulador de loja. Se você curte jogos aconchegantes (cozy), puzzles casuais, jogos de objetos escondidos, jogos sobre poções, alquimia e uma lojinha mágica só sua — este jogo é para você.',
      'É um jogo single-player e funciona sem internet; a conexão só é necessária para compras e vídeos opcionais com recompensa. Não há banners nem anúncios pop-up: um vídeo curto do Google AdMob em troca de um bônus só aparece quando você toca para assistir. Compras opcionais: gemas e pacotes de ingredientes com conteúdo visível. Em breve no iOS e no Android, em português (Brasil), inglês, russo, espanhol, alemão, francês, holandês, italiano, polonês, japonês, coreano, chinês tradicional e turco.',
    ],
    doTitle: 'O que você vai fazer',
    doList: [
      'Procurar ingredientes escondidos em clareiras mágicas 3D da floresta — cada uma parece um pequeno diorama.',
      'Preparar receitas mágicas no caldeirão: um estabilizador, um ingrediente principal, ervas do tempo e uma gota de cor.',
      'Criar seus próprios frascos — formato, tampa e cor da poção; os mais bonitos valem mais.',
      'Tocar a sua própria loja: clientes, reputação, feiras e missões.',
      'Acompanhar a história: a vovó saiu de férias e deixou a loja com você, e um sapo chamado Moren não para de exigir o que é dele.',
      'Moer seus achados no pilão, misturar na tigela e acrescentar glitter — cada mistura tem sua própria textura e cor.',
      'Alimentar seu familiar e decorar a loja.',
    ],
    faqTitle: 'Perguntas frequentes',
    faq: [
      { q: 'O Qevryno é grátis?', a: 'Sim. O jogo é gratuito e dá para jogar sem pagar nada. Compras opcionais: gemas e pacotes de ingredientes.' },
      { q: 'Funciona sem internet?', a: 'Sim. O jogo em si não precisa de conexão — prepare poções no avião ou debaixo do cobertor. A internet só é usada para compras e vídeos opcionais com recompensa.' },
      { q: 'Tem anúncios?', a: 'Só opcionais. Não há banners nem anúncios pop-up entre as telas. Em alguns lugares, se quiser, você pode assistir a um vídeo curto e ganhar um bônus — por exemplo, mana. Nada no jogo obriga você a assistir. Os vídeos são exibidos pelo Google AdMob; mais detalhes na Política de Privacidade.' },
      { q: 'Em quais plataformas?', a: 'iOS e Android, em português (Brasil), inglês, russo, espanhol, alemão, francês, holandês, italiano, polonês, japonês, coreano, chinês tradicional e turco.' },
      { q: 'É assustador ou estressante?', a: 'Nem um pouco. É um jogo calmo e aconchegante: música suave, nenhuma punição por errar e um gato de chapéu.' },
    ],
  },
  contact: {
    title: 'Fale conosco',
    subtitle: 'Uma dúvida sobre o Qevryno, um erro, uma compra ou um anúncio? Escreva para nós por e-mail.',
    write: 'Escrever um e-mail',
    mailSubject: 'Qevryno: suporte',
    tip: 'Conte qual é o seu aparelho e o que aconteceu — assim fica mais fácil ajudar.',
    info: {
      title: 'Contatos',
      email: 'E-mail',
      security: 'Segurança',
      legalName: 'Desenvolvedora',
      address: 'Endereço',
    },
    refunds: {
      title: 'Reembolsos e compras',
      description: 'Todas as compras são feitas pela Apple App Store ou pelo Google Play. Para pedir reembolso, fale com a loja de aplicativos:',
      apple: 'Apple App Store',
      appleUrl: 'https://support.apple.com/pt-br/HT204084',
      google: 'Google Play',
      googleUrl: 'https://support.google.com/googleplay/answer/2479637?hl=pt-BR',
      link: 'Pedir reembolso',
      note: 'Não recebemos pagamentos diretamente e não podemos fazer reembolsos. Se uma compra não chegou ao jogo, abra “Configurações → Restaurar compras” ou escreva para nós.',
    },
  },
  legal: {
    dataController: 'Controlador de dados',
    // Политика и условия есть на английском, русском и испанском; для остальных языков страница показывает английский текст и эту строку
    onlyIn: 'Este documento só está disponível em inglês, russo e espanhol. Abaixo, a versão em inglês.',
  },
};
